import { FeedbackPopupLayout } from '../../../components/popups/feedback-popup-layout/feedback-popup-layout';
import { BlueDeniedSpotIllustration } from '@y2/mango/components/illustrations/spot';
import { RoundButton } from '../../../components/round-button/round-button';
import texts from './lead-fail.texts.json';
import React from 'react';

type Props = {
  className?: string;
  onClose: () => void;
};

export const LeadFail = ({ className, onClose }: Props) => {
  return (
    <FeedbackPopupLayout
      className={className}
      onClose={onClose}
      illustration={<BlueDeniedSpotIllustration />}
      heading={texts.heading}
      message={texts.message}
      action={
        <RoundButton theme="primary" onClick={onClose}>
          {texts.backToProjectPage}
        </RoundButton>
      }
    />
  );
};
